import './LinksBlock.scss'

import {Block} from './Blocks'
import {LinkType} from '../../types'
import React from 'react'
import {Theme} from 'views/Theme'
import {style} from '../../util/style'

const styles = style('linksblock')

export type LinksBlockType = {
	links: Array<LinkType>
	show_related_pages: boolean
	related_pages_type: 'children' | 'sibling'
}

export const LinksBlock: React.FC<LinksBlockType & {container?: boolean}> = ({
	container,
	links
}) => {
	if (links?.length === 0) return null

	return (
		<Block className={styles()} container={container}>
			<div className={styles('items')}>
				{links.map((link) => {
					const linksToCurrentPage = link.url === location.pathname
					return (
						<div
							key={link.url}
							className={styles('items-item').mod({bold: linksToCurrentPage})}
						>
							<Theme.Link to={link.url}>
								{link.description || link.title}
							</Theme.Link>
						</div>
					)
				})}
			</div>
		</Block>
	)
}
